import * as L from 'leaflet';
import 'leaflet-gpx';

type Waypoint = {
  lat: number;
  lng: number;
};

export class SingleBalade {
  private mapElement: HTMLElement | null;
  private waypoints: Waypoint[] = [];
  private gpxUrl: string | undefined;
  private mapInstance: L.Map;
  private containerMobile: HTMLElement | null = null;
  private containerDesktop: HTMLElement | null = null;
  private resizeTimer: number | null = null;
  private readonly breakpoint = 1025

  constructor() {
    this.mapElement = document.querySelector<HTMLElement>('[data-map-single-balade]');

    if (!this.mapElement) {
      return;
    }

    this.gpxUrl = this.mapElement.dataset.gpx;
    this.waypoints = JSON.parse(this.mapElement.dataset.waypoints || '[]');
    this.containerMobile = document.querySelector('[data-container-mobile]');
    this.containerDesktop = document.querySelector('[data-container-desktop]');

    if (this.gpxUrl || this.waypoints.length > 0) {
      this.initMap();
      // this.initMore();
      window.addEventListener('resize', () => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer);
        }
        this.resizeTimer = window.setTimeout(() => {
          this.moveMapElement();
        }, 250);
      });

      this.moveMapElement();
    }
  }

  private initMore(): void {
    const moreButton = document.querySelector<HTMLButtonElement>('[data-more]');
    const moreText = document.querySelector<HTMLButtonElement>('[data-more-text]');

    if (!moreButton || !moreText) {
      return;
    }
    const isTextClamped = moreText.scrollHeight > moreText.offsetHeight;

    // Si le texte n'est pas coupé, on cache le bouton "Lire la suite"
    if (!isTextClamped) {
      moreButton.style.display = 'none';
      return;
    }

    moreButton.addEventListener('click', () => {
      moreText.classList.add('reveal')
      moreButton.style.display = 'none';
    });
  }

  private initMap(): void {
    this.mapInstance = L.map(this.mapElement, {
      scrollWheelZoom: false, // Désactive le zoom avec la molette
      doubleClickZoom: false,
      touchZoom: false,
      boxZoom: false,
      zoomControl: false,
      dragging: false,  // Désactive le déplacement
      keyboard: false
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapInstance);

    const startIconUrl = this.mapElement?.dataset.startIcon;
    const endIconUrl = this.mapElement?.dataset.endIcon;

    if (this.gpxUrl) {
      const gpxOptions: any = {
        async: true,
        polyline_options: { color: '#0036FF' },
        markers: {
          startIcon: startIconUrl,
          endIcon: endIconUrl,
          shadowUrl: ''
        },
        marker_options: {
          iconSize: [24, 24],
          iconAnchor: [12, 24]
        }
      };
      new (L as any).GPX(this.gpxUrl, gpxOptions).on('loaded', (e: any) => {
        this.mapInstance.fitBounds(e.target.getBounds());
      }).addTo(this.mapInstance);
    }
    const customIcon = L.divIcon({
      className: 'waypoint',
      iconSize: [8, 8],
      iconAnchor: [8, 8]
    });

    if (this.waypoints.length > 0) {
      const markers: L.Marker[] = [];
      this.waypoints.forEach(point => {
        if (typeof point.lat === 'number' && typeof point.lng === 'number') {
          const marker = L.marker([point.lat, point.lng], { icon: customIcon });
          markers.push(marker);
          marker.addTo(this.mapInstance);
        }
      });

      if (!this.gpxUrl && markers.length > 0) {
        const group = L.featureGroup(markers);
        this.mapInstance.fitBounds(group.getBounds().pad(0.5));
      }
    }
  }

  private moveMapElement(): void {
    if (!this.mapElement || !this.containerMobile || !this.containerDesktop) {
      return;
    }

    if (window.innerWidth < this.breakpoint) {
      //   console.log('Déplacement de la carte vers le conteneur mobile.');
      this.containerMobile.appendChild(this.mapElement);
    } else {
      //  console.log('Déplacement de la carte vers le conteneur desktop.');
      this.containerDesktop.prepend(this.mapElement);
    }
  }
}

export const singleBalade = new SingleBalade();